module.exports = __webpack_public_path__ + "img/results.5cd7ddef.png";